var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28",
    "data-name": "Group 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.891,
    height: 39.284,
    viewBox: "0 0 123.891 39.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M667.823,141.755v-.638c1.406-.175,1.584-.371,1.271-1.247-.265-.811-.692-1.954-1.162-3.205h-4.685c-.337.923-.648,1.821-.961,2.721-.448,1.337-.267,1.556,1.407,1.731v.638H658.8v-.638c1.428-.2,1.742-.348,2.5-2.256l4.62-11.471.782-.22c1.383,3.772,2.879,7.9,4.307,11.691.714,1.908,1.006,2.107,2.454,2.256v.638ZM665.7,130.238h-.067c-.692,1.824-1.384,3.664-2.031,5.445h4Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M688.8,138.247c-.133.746-.6,2.851-.8,3.508H677.75v-.638c1.9-.128,2.075-.283,2.075-2.146V130.26c0-1.864-.157-1.995-1.943-2.127V127.5h6.007v.634c-1.764.132-1.965.243-1.965,2.127V138.9c0,1.164.11,1.581.514,1.8a4.756,4.756,0,0,0,2.052.261c1.184,0,1.942-.107,2.456-.678a6.294,6.294,0,0,0,1.184-2.171Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M701.873,141.755v-.638c1.407-.175,1.586-.371,1.272-1.247-.267-.811-.69-1.954-1.16-3.205H697.3c-.336.923-.647,1.821-.961,2.721-.448,1.337-.267,1.556,1.406,1.731v.638h-4.888v-.638c1.429-.2,1.742-.348,2.5-2.256l4.62-11.471.782-.22c1.387,3.772,2.88,7.9,4.31,11.691.713,1.908,1,2.107,2.454,2.256v.638Zm-2.121-11.517h-.066c-.691,1.824-1.384,3.664-2.03,5.445h3.994Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M725.148,141.933a7.374,7.374,0,0,1-.757-.026,4.2,4.2,0,0,1-3.8-2.017c-.759-1.051-1.519-2.391-2.164-3.464a1.763,1.763,0,0,0-1.852-.9h-.648v3.445c0,1.863.2,2.018,1.962,2.146v.638h-6v-.638c1.786-.128,1.987-.283,1.987-2.146v-8.753c0-1.842-.18-1.953-1.9-2.085V127.5h5.649a6.48,6.48,0,0,1,3.637.747,3.279,3.279,0,0,1,1.5,2.872c0,1.907-1.206,3.048-2.837,3.749.38.683,1.294,2.152,1.965,3.14a17.472,17.472,0,0,0,1.786,2.322,3.415,3.415,0,0,0,1.561,1.009Zm-8.237-7.129a3.692,3.692,0,0,0,2.39-.615,3.2,3.2,0,0,0,1.183-2.719,2.945,2.945,0,0,0-3.148-3.249,2.163,2.163,0,0,0-1.182.222c-.157.132-.223.373-.223.942V134.8Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M743.469,135.748c-1.294.2-1.406.3-1.406,1.623v1.839a9.828,9.828,0,0,0,.157,2.084,23.461,23.461,0,0,1-5.024.788c-4.955,0-8.237-2.981-8.237-7.345,0-5.068,4.154-7.567,8.574-7.567a18.21,18.21,0,0,1,4.307.635c.067.77.178,1.976.357,3.445l-.671.152c-.534-2.651-2.229-3.443-4.351-3.443-3.283,0-5.735,2.456-5.735,6.493,0,3.2,1.85,6.842,6.027,6.842a4.052,4.052,0,0,0,1.83-.372c.422-.219.667-.525.667-1.383v-1.91c0-1.578-.133-1.709-2.344-1.881v-.638h5.849Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M756.545,141.755v-.638c1.406-.175,1.586-.371,1.272-1.247-.269-.811-.694-1.954-1.162-3.205h-4.688c-.331.923-.647,1.821-.962,2.721-.444,1.337-.265,1.556,1.408,1.731v.638h-4.886v-.638c1.427-.2,1.741-.348,2.5-2.256l4.621-11.471.78-.22c1.385,3.772,2.879,7.9,4.311,11.691.714,1.908,1,2.107,2.453,2.256v.638Zm-2.12-11.517h-.071c-.688,1.824-1.382,3.664-2.026,5.445h3.992Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M781.783,128.133c-1.248.069-1.762.352-1.875,1.319a36.178,36.178,0,0,0-.135,3.681v8.842h-.756l-9.466-11.406h-.045v5.4a35.874,35.874,0,0,0,.135,3.682c.112,1.1.6,1.379,2.166,1.467v.638h-5.338v-.638c1.274-.088,1.83-.371,1.944-1.421a36.125,36.125,0,0,0,.156-3.728v-4.785c0-1.557-.046-1.731-.446-2.235a2.416,2.416,0,0,0-1.966-.815V127.5H769.6l9.173,10.748h.069v-5.114a31.9,31.9,0,0,0-.158-3.639c-.109-.988-.623-1.271-2.186-1.361V127.5h5.289Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M668.165,109.637c.986,0,1.463-.472,1.463-1.415a1.5,1.5,0,0,0-1.463-1.452,1.443,1.443,0,0,0-1.461,1.452c0,.943.478,1.415,1.461,1.415",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M744.177,103.52c-2.272,0-4.085,2.1-4.356,5.56l1.668-.238a5.632,5.632,0,0,1-.326-1.717c0-1.507.864-2.395,1.969-2.395,1.543,0,3.248,1.421,5.119,4.23a21.868,21.868,0,0,1,3.13,6.354l-12.217.026v-.026H685.757v.03h-1.049c-1.82,0-2.743-1.065-2.743-3.2v-7.974c.085-.493.349-.577,1.164-.7v-.542h-5v.542c1.89.152,2.007.262,2.007,1.614l.043,7.6c0,2.719,1.284,4.08,3.818,4.08H754c-.151-2.219-1.256-4.875-3.337-8.011-2.294-3.486-4.441-5.232-6.49-5.232",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M746.108,120.689a1.16,1.16,0,0,0-1.308,1.3,1.139,1.139,0,0,0,1.308,1.272c.863,0,1.283-.412,1.283-1.241a1.323,1.323,0,0,0-1.283-1.332",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M775.316,102.907l-.068.02H771.4v.544c1.887.154,2,.262,2,1.616l.121,7.061a3.349,3.349,0,0,1-.661,2.221L766.744,102.8h-1.838l1.565,2.751,5.212,9.645a3.146,3.146,0,0,1-.924.15h-6.022l-.68,1.419h7.5c2.35,0,3.755-1.744,3.755-4.08v-8.7c.124-.306.4-.412,1.08-.515v-.544h-1.08Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M756.551,107.7c1.885.149,2,.26,2,1.611l.13,7.336a5.916,5.916,0,0,1-.838,3.073,6.451,6.451,0,0,1-3.421,2.746l.476.8c3.724-1.036,5.6-3.575,5.6-7.626v-7.518c.147-.24.438-.33,1.049-.421v-.544h-5Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M672.582,107.7c1.887.151,2,.262,2,1.617l.045,4.837a9.264,9.264,0,0,1-1.847,6,5.453,5.453,0,0,1-4.406,2.3,5.584,5.584,0,0,1-4.856-2.364,10.576,10.576,0,0,1-1.668-6.206l0-4.8c0-1.125.1-1.215,1.205-1.387v-.545h-5v.545c1.888.151,2.006.262,2.006,1.617v1.63c0,.072.032,3.064.032,3.064q0,9.256,7.866,9.247a8.123,8.123,0,0,0,6.2-2.331,8.521,8.521,0,0,0,2.232-6.181l-.014-5.659c0-1.125.1-1.215,1.207-1.387v-.545h-5Z",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M780.774,115.347v-8.923l.2-2.692a2.234,2.234,0,0,1,.889-.261v-.544h-.833l0-.02-.007.02h-4.162v.544c1.887.152,2,.261,2,1.615l.081,9.526c0,1.35-.118,1.463-2,1.613v.541h4.994v-.541c-.891-.136-1.118-.25-1.172-.878",
    transform: "translate(-658.055 -102.798)",
    fill: "#80008d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleLogo);
export default __webpack_public_path__ + "static/media/simple-logo.00f61f66f3b6f2f8c80987fe9824aa07.svg";
export { ForwardRef as ReactComponent };